type SCREEN_SIZES =
  | 'MAX'
  | 'LARGE_3X'
  | 'LARGE_2X'
  | 'LARGE_1X'
  | 'WIDE_DESKTOP'
  | 'DESKTOP'
  | 'TABLET'
  | 'PHONE'
  | 'SMALL';
export type BreakPoint = {
  [point in SCREEN_SIZES]: `${number}px`;
};

export const breakPoint: BreakPoint = {
  MAX: '9999px',
  LARGE_3X: '1999px',
  LARGE_2X: '1600px',
  LARGE_1X: '1200px',
  WIDE_DESKTOP: '992px',
  DESKTOP: '768px',
  TABLET: '576px',
  PHONE: '480px',
  SMALL: '400px',
};

export const LANDING_BREAKPOINT_VALUE = 1240;
export const LANDING_BREAKPOINT = `${LANDING_BREAKPOINT_VALUE}px`;
export const LARGE_SCREEN_BREAKPOINT_VALUE = 1200;
export const LARGE_SCREEN_BREAKPOINT = `${LARGE_SCREEN_BREAKPOINT_VALUE}px`;

export const mediaQueries = {
  DESKTOP_UP: `@media only screen and (min-width: ${breakPoint.DESKTOP})`,
  SMALL: `@media only screen and (max-width: ${breakPoint.SMALL})`,
  PHONE: `@media only screen and (max-width: 500px)`,
  GALLERY_SMALL_SCREEN: `@media only screen and (max-width: 1047px)`,
};

export type MediaQueriesType = typeof mediaQueries;

export default breakPoint;
